module.exports = __webpack_public_path__ + "static/media/6.ab244891.jpeg";